import { CommonModule } from '@angular/common';
import { Component, Input } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-modal-aguardando-download',
  standalone: true,
  imports: [CommonModule, MatIconModule],
  templateUrl: './modal-aguardando-download.component.html',
  styleUrl: './modal-aguardando-download.component.scss',
})
export class ModalAguardandoDownloadComponent {
  @Input() mensagem = 'Aguardando download...';
}
